import { EditRequestsComponent } from './edit-requests/edit-requests.component';
import { AddRequestsComponent } from './add-requests/add-requests.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListRequestsComponent } from './list-requests/list-requests.component';

export const routesRequests: Routes = [
    { path: 'requests', component: ListRequestsComponent},
    { path: 'requests/add', component: AddRequestsComponent},
    { path: 'requests/:id/edit', component: EditRequestsComponent}
];

export const RequestsRoutes: ModuleWithProviders = RouterModule.forChild(routesRequests);
